module.exports = "/images/logo/aw_black.svg";